<div appCopyable [appCopyableValue]="version" class="text-right text-xs">
    Versione del sistema: {{version}}
</div>
